import React from "react"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"

/* Pages */
import Home from "./pages/Home"
import Blog from "./pages/Blog"
import BlogPost from "./pages/BlogPost"
import Menu from "./pages/Menu"
import Contact from "./pages/Contact"
import RugasApp from "./pages/RugasApp"

/* Components */
import Header from "./components/Header"
import Footer from "./components/Footer"
import FloatingCallButton from "./components/FloatingCallButton"
import ScrollToTop from "./components/ScrollToTop"

export default function App() {
  return (
    <Router>
      <ScrollToTop behavior="smooth" />
      <div className="app">
        <Header />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/rugas-app" element={<RugasApp />} />
          </Routes>
        </main>
        <Footer />
        <FloatingCallButton />
      </div>
    </Router>
  )
}
